import TestPage from './screens/TestPage';
import HomePage from './screens/HomePage';
import PerspectivePage from './screens/PerspectivePage';
import CaseStudyPage from './screens/CaseStudyPage';
import PlateauAppPage from './screens/PlateauAppPage';
import HackathonPage from './screens/HackathonPage';
import MissionPage from './screens/MissionPage';
import ScrollRouter from './router/ScrollRouter';
import AboutPage from './screens/AboutPage';
import CityModelPage from './screens/CityModelPage';
import SitePolicyPage from './screens/SitePolicyPage';
import PerspectiveInterviewPage from './screens/PerspectiveInterviewPage';
import NewsPage from './screens/NewsPage';
import RoadmapPage from './screens/RoadmapPage';
import UseCasePage from './screens/UseCasePage';
import TrialServicePage, { TrialServiceItem } from './screens/TrialServicePage';
import ViewerPage from './screens/ViewerPage';
import TrialServiceHomePage from './screens/TrialServiceHomePage';

const pages = {
	"__default__": TestPage,
	"TestPage": TestPage,
	"ScrollRouter": ScrollRouter,
	"HomePage": HomePage,
	"MissionPage": MissionPage,
	"RoadmapPage": RoadmapPage,
	"PerspectivePage": PerspectivePage,
	"CaseStudyPage": CaseStudyPage,
	"PlateauAppPage": PlateauAppPage,
	"HackathonPage": HackathonPage,
	"AboutPage": AboutPage,
	"CityModelPage": CityModelPage,
	"SitePolicyPage": SitePolicyPage,
	"PerspectiveInterviewPage": PerspectiveInterviewPage,
	"NewsPage": NewsPage,
	"UseCasePage": UseCasePage,
	"TrialServiceHomePage": TrialServiceHomePage,
	"TrialServicePage": TrialServicePage,
	"TrialServiceItem": TrialServiceItem,
	"ViewerPage": ViewerPage,
};

export default pages;